/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { useEffect, useState } from "react"
import Header from "./header/header"
import PageFooter from "./page_footer/page_footer"

import useWindowDimensions from "./useWindowDimensions"
import ContextConsumer, { ContextProviderComponent } from "./context"

// import header from "./header/header"

const Layout = ({
  children,
  slideView,
  toggleView,
  heroImageFluid,
  slideIndex,
  location,
}) => {
  const url = location.pathname ? location.pathname : '';
  // console.log(url, ' href');

  const [rightPage, setRightPage] = useState({
    id: 0,
    path: '/welcome',
    correct: false,
  })
  const { height, width } = useWindowDimensions()
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          menuLinks {
            link
            id
          }
        }
      }
    }
  `)

  useEffect(() => {  

    let currentPath = window.location.pathname;
    let menuLinks = data.site.siteMetadata.menuLinks;
    for(let x = 0; x < menuLinks.length; x++) {
      if(menuLinks[x].link === currentPath && currentPath !== "/welcome") {
        const newRightPage = {
          id: menuLinks[x].id,
          path: menuLinks[x].link,
          correct: false,
        }
        setRightPage(newRightPage);
      }
    }
  }, [rightPage.id])
  
  return (
    <ContextProviderComponent>
      <ContextConsumer>
        {({ contextData, set, setPath }) => {

          return (
            <div style={{
              maxHeight: contextData.slideView ? 'none' : '100vh',
              overflow: 'hidden',
            }}>
              <Header
                slideView={contextData.slideView}
                siteTitle={data.site.siteMetadata.title}
                toggleView={()=>set({slideView:!contextData.slideView})}
                set={set}
                appWidth={width}
                appHeight={height}
              />
              <main>{children}</main>

              <PageFooter
                appWidth={width}
                slideView={contextData.slideView}
                toggleView={()=>{set({slideView:!contextData.slideView})}}
                slideIndex={contextData.slideIndex}
                navShow={contextData.path !== "/annualreport2019/" && contextData.path !== "/" && url !== "/"}
                setPath={(path)=>{set({path:path})}}
                set={set}
                appHeight={height}
              />
            </div>
          )
        }}
      </ContextConsumer>
    </ContextProviderComponent>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
